
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta } from "/vercel/path0/src/pages/index/index.vue?macro=true";
import { default as index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta } from "/vercel/path0/src/pages/2months/index.vue?macro=true";
import { default as indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta } from "/vercel/path0/src/pages/3months/index.vue?macro=true";
import { default as indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta } from "/vercel/path0/src/pages/6bus/index.vue?macro=true";
import { default as indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta } from "/vercel/path0/src/pages/6months/index.vue?macro=true";
import { default as index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta } from "/vercel/path0/src/pages/7bus/index.vue?macro=true";
import { default as indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta } from "/vercel/path0/src/pages/8bus/index.vue?macro=true";
import { default as indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta } from "/vercel/path0/src/pages/9bus/index.vue?macro=true";
import { default as indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta } from "/vercel/path0/src/pages/about-us/index.vue?macro=true";
import { default as indexhlxs1zTCih0cWL7LKPLs5ek7rp2DGeppIogsd_n_Ln4Meta } from "/vercel/path0/src/pages/account/data/index.vue?macro=true";
import { default as indexG7ItjoYNZ5TWa4BXYuejjXHq0lyWlCKwD7OAwDfiP4AMeta } from "/vercel/path0/src/pages/account/index.vue?macro=true";
import { default as indexDTrlOrP2az_45oKHLerT2S9_45EfWdQFSRmIRPF7YCVfPJ8Meta } from "/vercel/path0/src/pages/account/language/index.vue?macro=true";
import { default as index5NRJhspMAxRhqY55Z338_t0vBtDWU2PjXegdySfxtykMeta } from "/vercel/path0/src/pages/account/notifications/index.vue?macro=true";
import { default as indexFazVrM2Bj2e6NBYMLZm8pcYkjFhvioMJ1QblameDAhAMeta } from "/vercel/path0/src/pages/account/orders/[id]/index.vue?macro=true";
import { default as indexZGqlqhUUsctLmp_45gegU9GWLSV10YFkB53rdW8ZZWLgcMeta } from "/vercel/path0/src/pages/account/orders/index.vue?macro=true";
import { default as indexTm_x82vUTb0TmM2c1nCbEH_UPDogtuPvUsRdczbuDAIMeta } from "/vercel/path0/src/pages/account/password/index.vue?macro=true";
import { default as index5zuVV8BAHUmZe8pIuiFVauptzAZQy3RxOpmmRQJjeksMeta } from "/vercel/path0/src/pages/blog/[...newsTitle]/index.vue?macro=true";
import { default as indexPXN_o1dAOGWHeDzMAmp94WJfWWDO2xvbajPFyoS_45U48Meta } from "/vercel/path0/src/pages/blog/index.vue?macro=true";
import { default as indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta } from "/vercel/path0/src/pages/bus-rental/index.vue?macro=true";
import { default as indexc9WkL0F9HkHEMt8vAYPnZl_MwWLwdwh7KVM5caUqYQ0Meta } from "/vercel/path0/src/pages/business-trip-rental/index.vue?macro=true";
import { default as index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta } from "/vercel/path0/src/pages/car-rental-[urlSlug]/index.vue?macro=true";
import { default as indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta } from "/vercel/path0/src/pages/cars/index.vue?macro=true";
import { default as indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta } from "/vercel/path0/src/pages/contact/index.vue?macro=true";
import { default as indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta } from "/vercel/path0/src/pages/create-new-password/index.vue?macro=true";
import { default as indexcAmyIMIKInERpZsbNCkpas72IYqRceCD3gvaFy_qxtIMeta } from "/vercel/path0/src/pages/delete-account/index.vue?macro=true";
import { default as index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta } from "/vercel/path0/src/pages/delivery-bus-rental/index.vue?macro=true";
import { default as indexrLEoJ_45Yma8AgZDht2PNuSqLmua6Cud2CEhI4TuPDdZoMeta } from "/vercel/path0/src/pages/documents/index.vue?macro=true";
import { default as indexXGPueQXfTohB_45GGjq__45wbjXMRBpeXbsl065C4fFjG2EMeta } from "/vercel/path0/src/pages/electric-car-rental/index.vue?macro=true";
import { default as indexExboAN5BgVPlFbSyMtusNAdZuLF_DrGHlx23DnHWIAkMeta } from "/vercel/path0/src/pages/faq/index.vue?macro=true";
import { default as indexdjYiYxrZo4jvcwH8e3cNpHWk44665A7mVcTcP9P8Tf8Meta } from "/vercel/path0/src/pages/general-terms-and-conditions/index.vue?macro=true";
import { default as indexzU8cBsowFdhoI47By5CQCeWGuEfwMVmVz9FCpZUnZ78Meta } from "/vercel/path0/src/pages/holiday-abroad-rental/index.vue?macro=true";
import { default as indexzY7P9_h0HCeqKJXBnldLFsgwGCYN9WdaaAQaqjRaqU0Meta } from "/vercel/path0/src/pages/holiday-rental/index.vue?macro=true";
import { default as indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta } from "/vercel/path0/src/pages/insurance-replacement/index.vue?macro=true";
import { default as indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta } from "/vercel/path0/src/pages/locations/index.vue?macro=true";
import { default as index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta } from "/vercel/path0/src/pages/long-term/index.vue?macro=true";
import { default as indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta } from "/vercel/path0/src/pages/loyalty-program/index.vue?macro=true";
import { default as index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta } from "/vercel/path0/src/pages/medium-term/index.vue?macro=true";
import { default as indexNvjP9wySKf3_aee8kWRb4UnByot3_45AUbm17sgDLRUrIMeta } from "/vercel/path0/src/pages/privacy-policy/index.vue?macro=true";
import { default as indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta } from "/vercel/path0/src/pages/refrigeration-van-rental/index.vue?macro=true";
import { default as indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta } from "/vercel/path0/src/pages/rent-tesla/index.vue?macro=true";
import { default as indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta } from "/vercel/path0/src/pages/reservation/completed/[orderID]/index.vue?macro=true";
import { default as indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta } from "/vercel/path0/src/pages/reservation/index.vue?macro=true";
import { default as index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta } from "/vercel/path0/src/pages/short-term/index.vue?macro=true";
import { default as indexKE3SzNPACD6Is2mCcJSJWHe5CfRqWmfWoLONcYsyU3cMeta } from "/vercel/path0/src/pages/sign-in/index.vue?macro=true";
import { default as indexxR9dnca3GnBhVzS7HkfJPz2ac9t7r9CeiWj1VA5gEbYMeta } from "/vercel/path0/src/pages/terms-of-service/index.vue?macro=true";
import { default as indexxnt_457_45JeCffk_9ux0L4N0LipsCcSuMSLtxCbEgzFI10Meta } from "/vercel/path0/src/pages/verify-email/index.vue?macro=true";
import { default as indexBggzO1uP_45_45gMJuHAKxtuibnRB8VU_j_45CcGtOgbDnpXsMeta } from "/vercel/path0/src/pages/weekend-rental/index.vue?macro=true";
import { default as component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta?.name ?? "index",
    path: indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta?.path ?? "/",
    props: indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta?.props ?? false,
    meta: indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta || {},
    alias: indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta?.alias || [],
    redirect: indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/index/index.vue")
  },
  {
    name: index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta?.name ?? "2months___en",
    path: index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta?.path ?? "/en/for-a-2-months-rental",
    props: index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta?.props ?? false,
    meta: index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta || {},
    alias: index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta?.alias || [],
    redirect: index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/2months/index.vue")
  },
  {
    name: index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta?.name ?? "2months___pl",
    path: index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta?.path ?? "/pl/wynajem-auta-na-2-miesiace",
    props: index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta?.props ?? false,
    meta: index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta || {},
    alias: index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta?.alias || [],
    redirect: index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/2months/index.vue")
  },
  {
    name: indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta?.name ?? "3months___en",
    path: indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta?.path ?? "/en/for-a-3-months-rental",
    props: indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta?.props ?? false,
    meta: indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta || {},
    alias: indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta?.alias || [],
    redirect: indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/3months/index.vue")
  },
  {
    name: indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta?.name ?? "3months___pl",
    path: indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta?.path ?? "/pl/wynajem-auta-na-3-miesiace",
    props: indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta?.props ?? false,
    meta: indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta || {},
    alias: indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta?.alias || [],
    redirect: indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/3months/index.vue")
  },
  {
    name: indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta?.name ?? "6bus___en",
    path: indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta?.path ?? "/en/6-seat-bus-rental",
    props: indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta?.props ?? false,
    meta: indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta || {},
    alias: indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta?.alias || [],
    redirect: indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/6bus/index.vue")
  },
  {
    name: indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta?.name ?? "6bus___pl",
    path: indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta?.path ?? "/pl/wynajem-busa-6-osobowego",
    props: indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta?.props ?? false,
    meta: indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta || {},
    alias: indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta?.alias || [],
    redirect: indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/6bus/index.vue")
  },
  {
    name: indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta?.name ?? "6months___en",
    path: indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta?.path ?? "/en/for-a-6-months-rental",
    props: indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta?.props ?? false,
    meta: indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta || {},
    alias: indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta?.alias || [],
    redirect: indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/6months/index.vue")
  },
  {
    name: indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta?.name ?? "6months___pl",
    path: indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta?.path ?? "/pl/wynajem-auta-na-6-miesiecy",
    props: indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta?.props ?? false,
    meta: indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta || {},
    alias: indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta?.alias || [],
    redirect: indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/6months/index.vue")
  },
  {
    name: index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta?.name ?? "7bus___en",
    path: index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta?.path ?? "/en/7-seat-bus-rental",
    props: index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta?.props ?? false,
    meta: index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta || {},
    alias: index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta?.alias || [],
    redirect: index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/7bus/index.vue")
  },
  {
    name: index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta?.name ?? "7bus___pl",
    path: index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta?.path ?? "/pl/wynajem-busa-7-osobowego",
    props: index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta?.props ?? false,
    meta: index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta || {},
    alias: index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta?.alias || [],
    redirect: index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/7bus/index.vue")
  },
  {
    name: indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta?.name ?? "8bus___en",
    path: indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta?.path ?? "/en/8-seat-bus-rental",
    props: indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta?.props ?? false,
    meta: indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta || {},
    alias: indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta?.alias || [],
    redirect: indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/8bus/index.vue")
  },
  {
    name: indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta?.name ?? "8bus___pl",
    path: indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta?.path ?? "/pl/wynajem-busa-8-osobowego",
    props: indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta?.props ?? false,
    meta: indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta || {},
    alias: indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta?.alias || [],
    redirect: indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/8bus/index.vue")
  },
  {
    name: indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta?.name ?? "9bus___en",
    path: indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta?.path ?? "/en/9-seat-bus-rental",
    props: indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta?.props ?? false,
    meta: indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta || {},
    alias: indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta?.alias || [],
    redirect: indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/9bus/index.vue")
  },
  {
    name: indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta?.name ?? "9bus___pl",
    path: indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta?.path ?? "/pl/wynajem-busa-9-osobowego",
    props: indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta?.props ?? false,
    meta: indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta || {},
    alias: indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta?.alias || [],
    redirect: indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/9bus/index.vue")
  },
  {
    name: indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta?.name ?? "about-us___en",
    path: indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta?.path ?? "/en/about-us",
    props: indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta?.props ?? false,
    meta: indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta || {},
    alias: indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta?.alias || [],
    redirect: indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/about-us/index.vue")
  },
  {
    name: indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta?.name ?? "about-us___pl",
    path: indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta?.path ?? "/pl/onas",
    props: indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta?.props ?? false,
    meta: indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta || {},
    alias: indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta?.alias || [],
    redirect: indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/about-us/index.vue")
  },
  {
    name: indexhlxs1zTCih0cWL7LKPLs5ek7rp2DGeppIogsd_n_Ln4Meta?.name ?? "account-data___en",
    path: indexhlxs1zTCih0cWL7LKPLs5ek7rp2DGeppIogsd_n_Ln4Meta?.path ?? "/en/account/data",
    props: indexhlxs1zTCih0cWL7LKPLs5ek7rp2DGeppIogsd_n_Ln4Meta?.props ?? false,
    meta: indexhlxs1zTCih0cWL7LKPLs5ek7rp2DGeppIogsd_n_Ln4Meta || {},
    alias: indexhlxs1zTCih0cWL7LKPLs5ek7rp2DGeppIogsd_n_Ln4Meta?.alias || [],
    redirect: indexhlxs1zTCih0cWL7LKPLs5ek7rp2DGeppIogsd_n_Ln4Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/account/data/index.vue")
  },
  {
    name: indexhlxs1zTCih0cWL7LKPLs5ek7rp2DGeppIogsd_n_Ln4Meta?.name ?? "account-data___pl",
    path: indexhlxs1zTCih0cWL7LKPLs5ek7rp2DGeppIogsd_n_Ln4Meta?.path ?? "/pl/konto/zmien-dane",
    props: indexhlxs1zTCih0cWL7LKPLs5ek7rp2DGeppIogsd_n_Ln4Meta?.props ?? false,
    meta: indexhlxs1zTCih0cWL7LKPLs5ek7rp2DGeppIogsd_n_Ln4Meta || {},
    alias: indexhlxs1zTCih0cWL7LKPLs5ek7rp2DGeppIogsd_n_Ln4Meta?.alias || [],
    redirect: indexhlxs1zTCih0cWL7LKPLs5ek7rp2DGeppIogsd_n_Ln4Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/account/data/index.vue")
  },
  {
    name: indexG7ItjoYNZ5TWa4BXYuejjXHq0lyWlCKwD7OAwDfiP4AMeta?.name ?? "account___en",
    path: indexG7ItjoYNZ5TWa4BXYuejjXHq0lyWlCKwD7OAwDfiP4AMeta?.path ?? "/en/account",
    props: indexG7ItjoYNZ5TWa4BXYuejjXHq0lyWlCKwD7OAwDfiP4AMeta?.props ?? false,
    meta: indexG7ItjoYNZ5TWa4BXYuejjXHq0lyWlCKwD7OAwDfiP4AMeta || {},
    alias: indexG7ItjoYNZ5TWa4BXYuejjXHq0lyWlCKwD7OAwDfiP4AMeta?.alias || [],
    redirect: indexG7ItjoYNZ5TWa4BXYuejjXHq0lyWlCKwD7OAwDfiP4AMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/account/index.vue")
  },
  {
    name: indexG7ItjoYNZ5TWa4BXYuejjXHq0lyWlCKwD7OAwDfiP4AMeta?.name ?? "account___pl",
    path: indexG7ItjoYNZ5TWa4BXYuejjXHq0lyWlCKwD7OAwDfiP4AMeta?.path ?? "/pl/konto",
    props: indexG7ItjoYNZ5TWa4BXYuejjXHq0lyWlCKwD7OAwDfiP4AMeta?.props ?? false,
    meta: indexG7ItjoYNZ5TWa4BXYuejjXHq0lyWlCKwD7OAwDfiP4AMeta || {},
    alias: indexG7ItjoYNZ5TWa4BXYuejjXHq0lyWlCKwD7OAwDfiP4AMeta?.alias || [],
    redirect: indexG7ItjoYNZ5TWa4BXYuejjXHq0lyWlCKwD7OAwDfiP4AMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/account/index.vue")
  },
  {
    name: indexDTrlOrP2az_45oKHLerT2S9_45EfWdQFSRmIRPF7YCVfPJ8Meta?.name ?? "account-language___en",
    path: indexDTrlOrP2az_45oKHLerT2S9_45EfWdQFSRmIRPF7YCVfPJ8Meta?.path ?? "/en/account/language",
    props: indexDTrlOrP2az_45oKHLerT2S9_45EfWdQFSRmIRPF7YCVfPJ8Meta?.props ?? false,
    meta: indexDTrlOrP2az_45oKHLerT2S9_45EfWdQFSRmIRPF7YCVfPJ8Meta || {},
    alias: indexDTrlOrP2az_45oKHLerT2S9_45EfWdQFSRmIRPF7YCVfPJ8Meta?.alias || [],
    redirect: indexDTrlOrP2az_45oKHLerT2S9_45EfWdQFSRmIRPF7YCVfPJ8Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/account/language/index.vue")
  },
  {
    name: indexDTrlOrP2az_45oKHLerT2S9_45EfWdQFSRmIRPF7YCVfPJ8Meta?.name ?? "account-language___pl",
    path: indexDTrlOrP2az_45oKHLerT2S9_45EfWdQFSRmIRPF7YCVfPJ8Meta?.path ?? "/pl/konto/jezyk",
    props: indexDTrlOrP2az_45oKHLerT2S9_45EfWdQFSRmIRPF7YCVfPJ8Meta?.props ?? false,
    meta: indexDTrlOrP2az_45oKHLerT2S9_45EfWdQFSRmIRPF7YCVfPJ8Meta || {},
    alias: indexDTrlOrP2az_45oKHLerT2S9_45EfWdQFSRmIRPF7YCVfPJ8Meta?.alias || [],
    redirect: indexDTrlOrP2az_45oKHLerT2S9_45EfWdQFSRmIRPF7YCVfPJ8Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/account/language/index.vue")
  },
  {
    name: index5NRJhspMAxRhqY55Z338_t0vBtDWU2PjXegdySfxtykMeta?.name ?? "account-notifications___en",
    path: index5NRJhspMAxRhqY55Z338_t0vBtDWU2PjXegdySfxtykMeta?.path ?? "/en/account/notifications",
    props: index5NRJhspMAxRhqY55Z338_t0vBtDWU2PjXegdySfxtykMeta?.props ?? false,
    meta: index5NRJhspMAxRhqY55Z338_t0vBtDWU2PjXegdySfxtykMeta || {},
    alias: index5NRJhspMAxRhqY55Z338_t0vBtDWU2PjXegdySfxtykMeta?.alias || [],
    redirect: index5NRJhspMAxRhqY55Z338_t0vBtDWU2PjXegdySfxtykMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/account/notifications/index.vue")
  },
  {
    name: index5NRJhspMAxRhqY55Z338_t0vBtDWU2PjXegdySfxtykMeta?.name ?? "account-notifications___pl",
    path: index5NRJhspMAxRhqY55Z338_t0vBtDWU2PjXegdySfxtykMeta?.path ?? "/pl/konto/powiadomienia",
    props: index5NRJhspMAxRhqY55Z338_t0vBtDWU2PjXegdySfxtykMeta?.props ?? false,
    meta: index5NRJhspMAxRhqY55Z338_t0vBtDWU2PjXegdySfxtykMeta || {},
    alias: index5NRJhspMAxRhqY55Z338_t0vBtDWU2PjXegdySfxtykMeta?.alias || [],
    redirect: index5NRJhspMAxRhqY55Z338_t0vBtDWU2PjXegdySfxtykMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/account/notifications/index.vue")
  },
  {
    name: indexFazVrM2Bj2e6NBYMLZm8pcYkjFhvioMJ1QblameDAhAMeta?.name ?? "account-orders-id___en",
    path: indexFazVrM2Bj2e6NBYMLZm8pcYkjFhvioMJ1QblameDAhAMeta?.path ?? "/en/account/orders/:id()",
    props: indexFazVrM2Bj2e6NBYMLZm8pcYkjFhvioMJ1QblameDAhAMeta?.props ?? false,
    meta: indexFazVrM2Bj2e6NBYMLZm8pcYkjFhvioMJ1QblameDAhAMeta || {},
    alias: indexFazVrM2Bj2e6NBYMLZm8pcYkjFhvioMJ1QblameDAhAMeta?.alias || [],
    redirect: indexFazVrM2Bj2e6NBYMLZm8pcYkjFhvioMJ1QblameDAhAMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/account/orders/[id]/index.vue")
  },
  {
    name: indexFazVrM2Bj2e6NBYMLZm8pcYkjFhvioMJ1QblameDAhAMeta?.name ?? "account-orders-id___pl",
    path: indexFazVrM2Bj2e6NBYMLZm8pcYkjFhvioMJ1QblameDAhAMeta?.path ?? "/pl/account/orders/:id()",
    props: indexFazVrM2Bj2e6NBYMLZm8pcYkjFhvioMJ1QblameDAhAMeta?.props ?? false,
    meta: indexFazVrM2Bj2e6NBYMLZm8pcYkjFhvioMJ1QblameDAhAMeta || {},
    alias: indexFazVrM2Bj2e6NBYMLZm8pcYkjFhvioMJ1QblameDAhAMeta?.alias || [],
    redirect: indexFazVrM2Bj2e6NBYMLZm8pcYkjFhvioMJ1QblameDAhAMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/account/orders/[id]/index.vue")
  },
  {
    name: indexZGqlqhUUsctLmp_45gegU9GWLSV10YFkB53rdW8ZZWLgcMeta?.name ?? "account-orders___en",
    path: indexZGqlqhUUsctLmp_45gegU9GWLSV10YFkB53rdW8ZZWLgcMeta?.path ?? "/en/account/orders",
    props: indexZGqlqhUUsctLmp_45gegU9GWLSV10YFkB53rdW8ZZWLgcMeta?.props ?? false,
    meta: indexZGqlqhUUsctLmp_45gegU9GWLSV10YFkB53rdW8ZZWLgcMeta || {},
    alias: indexZGqlqhUUsctLmp_45gegU9GWLSV10YFkB53rdW8ZZWLgcMeta?.alias || [],
    redirect: indexZGqlqhUUsctLmp_45gegU9GWLSV10YFkB53rdW8ZZWLgcMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/account/orders/index.vue")
  },
  {
    name: indexZGqlqhUUsctLmp_45gegU9GWLSV10YFkB53rdW8ZZWLgcMeta?.name ?? "account-orders___pl",
    path: indexZGqlqhUUsctLmp_45gegU9GWLSV10YFkB53rdW8ZZWLgcMeta?.path ?? "/pl/konto/zamowienia",
    props: indexZGqlqhUUsctLmp_45gegU9GWLSV10YFkB53rdW8ZZWLgcMeta?.props ?? false,
    meta: indexZGqlqhUUsctLmp_45gegU9GWLSV10YFkB53rdW8ZZWLgcMeta || {},
    alias: indexZGqlqhUUsctLmp_45gegU9GWLSV10YFkB53rdW8ZZWLgcMeta?.alias || [],
    redirect: indexZGqlqhUUsctLmp_45gegU9GWLSV10YFkB53rdW8ZZWLgcMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/account/orders/index.vue")
  },
  {
    name: indexTm_x82vUTb0TmM2c1nCbEH_UPDogtuPvUsRdczbuDAIMeta?.name ?? "account-password___en",
    path: indexTm_x82vUTb0TmM2c1nCbEH_UPDogtuPvUsRdczbuDAIMeta?.path ?? "/en/account/password",
    props: indexTm_x82vUTb0TmM2c1nCbEH_UPDogtuPvUsRdczbuDAIMeta?.props ?? false,
    meta: indexTm_x82vUTb0TmM2c1nCbEH_UPDogtuPvUsRdczbuDAIMeta || {},
    alias: indexTm_x82vUTb0TmM2c1nCbEH_UPDogtuPvUsRdczbuDAIMeta?.alias || [],
    redirect: indexTm_x82vUTb0TmM2c1nCbEH_UPDogtuPvUsRdczbuDAIMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/account/password/index.vue")
  },
  {
    name: indexTm_x82vUTb0TmM2c1nCbEH_UPDogtuPvUsRdczbuDAIMeta?.name ?? "account-password___pl",
    path: indexTm_x82vUTb0TmM2c1nCbEH_UPDogtuPvUsRdczbuDAIMeta?.path ?? "/pl/konto/haslo",
    props: indexTm_x82vUTb0TmM2c1nCbEH_UPDogtuPvUsRdczbuDAIMeta?.props ?? false,
    meta: indexTm_x82vUTb0TmM2c1nCbEH_UPDogtuPvUsRdczbuDAIMeta || {},
    alias: indexTm_x82vUTb0TmM2c1nCbEH_UPDogtuPvUsRdczbuDAIMeta?.alias || [],
    redirect: indexTm_x82vUTb0TmM2c1nCbEH_UPDogtuPvUsRdczbuDAIMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/account/password/index.vue")
  },
  {
    name: index5zuVV8BAHUmZe8pIuiFVauptzAZQy3RxOpmmRQJjeksMeta?.name ?? "blog-newsTitle___en",
    path: index5zuVV8BAHUmZe8pIuiFVauptzAZQy3RxOpmmRQJjeksMeta?.path ?? "/en/blog/:newsTitle(.*)*",
    props: index5zuVV8BAHUmZe8pIuiFVauptzAZQy3RxOpmmRQJjeksMeta?.props ?? false,
    meta: index5zuVV8BAHUmZe8pIuiFVauptzAZQy3RxOpmmRQJjeksMeta || {},
    alias: index5zuVV8BAHUmZe8pIuiFVauptzAZQy3RxOpmmRQJjeksMeta?.alias || [],
    redirect: index5zuVV8BAHUmZe8pIuiFVauptzAZQy3RxOpmmRQJjeksMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/blog/[...newsTitle]/index.vue")
  },
  {
    name: index5zuVV8BAHUmZe8pIuiFVauptzAZQy3RxOpmmRQJjeksMeta?.name ?? "blog-newsTitle___pl",
    path: index5zuVV8BAHUmZe8pIuiFVauptzAZQy3RxOpmmRQJjeksMeta?.path ?? "/pl/blog/:newsTitle(.*)*",
    props: index5zuVV8BAHUmZe8pIuiFVauptzAZQy3RxOpmmRQJjeksMeta?.props ?? false,
    meta: index5zuVV8BAHUmZe8pIuiFVauptzAZQy3RxOpmmRQJjeksMeta || {},
    alias: index5zuVV8BAHUmZe8pIuiFVauptzAZQy3RxOpmmRQJjeksMeta?.alias || [],
    redirect: index5zuVV8BAHUmZe8pIuiFVauptzAZQy3RxOpmmRQJjeksMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/blog/[...newsTitle]/index.vue")
  },
  {
    name: indexPXN_o1dAOGWHeDzMAmp94WJfWWDO2xvbajPFyoS_45U48Meta?.name ?? "blog___en",
    path: indexPXN_o1dAOGWHeDzMAmp94WJfWWDO2xvbajPFyoS_45U48Meta?.path ?? "/en/blog",
    props: indexPXN_o1dAOGWHeDzMAmp94WJfWWDO2xvbajPFyoS_45U48Meta?.props ?? false,
    meta: indexPXN_o1dAOGWHeDzMAmp94WJfWWDO2xvbajPFyoS_45U48Meta || {},
    alias: indexPXN_o1dAOGWHeDzMAmp94WJfWWDO2xvbajPFyoS_45U48Meta?.alias || [],
    redirect: indexPXN_o1dAOGWHeDzMAmp94WJfWWDO2xvbajPFyoS_45U48Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/blog/index.vue")
  },
  {
    name: indexPXN_o1dAOGWHeDzMAmp94WJfWWDO2xvbajPFyoS_45U48Meta?.name ?? "blog___pl",
    path: indexPXN_o1dAOGWHeDzMAmp94WJfWWDO2xvbajPFyoS_45U48Meta?.path ?? "/pl/blog",
    props: indexPXN_o1dAOGWHeDzMAmp94WJfWWDO2xvbajPFyoS_45U48Meta?.props ?? false,
    meta: indexPXN_o1dAOGWHeDzMAmp94WJfWWDO2xvbajPFyoS_45U48Meta || {},
    alias: indexPXN_o1dAOGWHeDzMAmp94WJfWWDO2xvbajPFyoS_45U48Meta?.alias || [],
    redirect: indexPXN_o1dAOGWHeDzMAmp94WJfWWDO2xvbajPFyoS_45U48Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/blog/index.vue")
  },
  {
    name: indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta?.name ?? "bus-rental___en",
    path: indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta?.path ?? "/en/passenger-bus-rental",
    props: indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta?.props ?? false,
    meta: indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta || {},
    alias: indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta?.alias || [],
    redirect: indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/bus-rental/index.vue")
  },
  {
    name: indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta?.name ?? "bus-rental___pl",
    path: indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta?.path ?? "/pl/wynajem-busow-osobowych",
    props: indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta?.props ?? false,
    meta: indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta || {},
    alias: indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta?.alias || [],
    redirect: indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/bus-rental/index.vue")
  },
  {
    name: indexc9WkL0F9HkHEMt8vAYPnZl_MwWLwdwh7KVM5caUqYQ0Meta?.name ?? "business-trip-rental___en",
    path: indexc9WkL0F9HkHEMt8vAYPnZl_MwWLwdwh7KVM5caUqYQ0Meta?.path ?? "/en/wynajem-auta-na-podroz-sluzbowa",
    props: indexc9WkL0F9HkHEMt8vAYPnZl_MwWLwdwh7KVM5caUqYQ0Meta?.props ?? false,
    meta: indexc9WkL0F9HkHEMt8vAYPnZl_MwWLwdwh7KVM5caUqYQ0Meta || {},
    alias: indexc9WkL0F9HkHEMt8vAYPnZl_MwWLwdwh7KVM5caUqYQ0Meta?.alias || [],
    redirect: indexc9WkL0F9HkHEMt8vAYPnZl_MwWLwdwh7KVM5caUqYQ0Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/business-trip-rental/index.vue")
  },
  {
    name: indexc9WkL0F9HkHEMt8vAYPnZl_MwWLwdwh7KVM5caUqYQ0Meta?.name ?? "business-trip-rental___pl",
    path: indexc9WkL0F9HkHEMt8vAYPnZl_MwWLwdwh7KVM5caUqYQ0Meta?.path ?? "/pl/wynajem-auta-na-podroz-sluzbowa",
    props: indexc9WkL0F9HkHEMt8vAYPnZl_MwWLwdwh7KVM5caUqYQ0Meta?.props ?? false,
    meta: indexc9WkL0F9HkHEMt8vAYPnZl_MwWLwdwh7KVM5caUqYQ0Meta || {},
    alias: indexc9WkL0F9HkHEMt8vAYPnZl_MwWLwdwh7KVM5caUqYQ0Meta?.alias || [],
    redirect: indexc9WkL0F9HkHEMt8vAYPnZl_MwWLwdwh7KVM5caUqYQ0Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/business-trip-rental/index.vue")
  },
  {
    name: index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta?.name ?? "car-rental-urlSlug___en",
    path: index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta?.path ?? "/en/car-rental-:urlSlug()",
    props: index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta?.props ?? false,
    meta: index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta || {},
    alias: index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta?.alias || [],
    redirect: index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/car-rental-[urlSlug]/index.vue")
  },
  {
    name: index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta?.name ?? "car-rental-urlSlug___pl",
    path: index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta?.path ?? "/pl/wypozyczalnia-samochodow-:urlSlug()",
    props: index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta?.props ?? false,
    meta: index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta || {},
    alias: index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta?.alias || [],
    redirect: index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/car-rental-[urlSlug]/index.vue")
  },
  {
    name: indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta?.name ?? "cars___en",
    path: indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta?.path ?? "/en/cars",
    props: indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta?.props ?? false,
    meta: indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta || {},
    alias: indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta?.alias || [],
    redirect: indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/cars/index.vue")
  },
  {
    name: indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta?.name ?? "cars___pl",
    path: indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta?.path ?? "/pl/samochody",
    props: indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta?.props ?? false,
    meta: indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta || {},
    alias: indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta?.alias || [],
    redirect: indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/cars/index.vue")
  },
  {
    name: indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta?.name ?? "contact___en",
    path: indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta?.path ?? "/en/contact",
    props: indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta?.props ?? false,
    meta: indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta || {},
    alias: indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta?.alias || [],
    redirect: indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/contact/index.vue")
  },
  {
    name: indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta?.name ?? "contact___pl",
    path: indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta?.path ?? "/pl/kontakt",
    props: indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta?.props ?? false,
    meta: indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta || {},
    alias: indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta?.alias || [],
    redirect: indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/contact/index.vue")
  },
  {
    name: indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta?.name ?? "create-new-password___en",
    path: indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta?.path ?? "/en/create-new-password",
    props: indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta?.props ?? false,
    meta: indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta || {},
    alias: indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta?.alias || [],
    redirect: indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/create-new-password/index.vue")
  },
  {
    name: indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta?.name ?? "create-new-password___pl",
    path: indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta?.path ?? "/pl/nowe-haslo",
    props: indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta?.props ?? false,
    meta: indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta || {},
    alias: indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta?.alias || [],
    redirect: indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/create-new-password/index.vue")
  },
  {
    name: indexcAmyIMIKInERpZsbNCkpas72IYqRceCD3gvaFy_qxtIMeta?.name ?? "delete-account___en",
    path: indexcAmyIMIKInERpZsbNCkpas72IYqRceCD3gvaFy_qxtIMeta?.path ?? "/en/delete-account",
    props: indexcAmyIMIKInERpZsbNCkpas72IYqRceCD3gvaFy_qxtIMeta?.props ?? false,
    meta: indexcAmyIMIKInERpZsbNCkpas72IYqRceCD3gvaFy_qxtIMeta || {},
    alias: indexcAmyIMIKInERpZsbNCkpas72IYqRceCD3gvaFy_qxtIMeta?.alias || [],
    redirect: indexcAmyIMIKInERpZsbNCkpas72IYqRceCD3gvaFy_qxtIMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/delete-account/index.vue")
  },
  {
    name: indexcAmyIMIKInERpZsbNCkpas72IYqRceCD3gvaFy_qxtIMeta?.name ?? "delete-account___pl",
    path: indexcAmyIMIKInERpZsbNCkpas72IYqRceCD3gvaFy_qxtIMeta?.path ?? "/pl/usun-konto",
    props: indexcAmyIMIKInERpZsbNCkpas72IYqRceCD3gvaFy_qxtIMeta?.props ?? false,
    meta: indexcAmyIMIKInERpZsbNCkpas72IYqRceCD3gvaFy_qxtIMeta || {},
    alias: indexcAmyIMIKInERpZsbNCkpas72IYqRceCD3gvaFy_qxtIMeta?.alias || [],
    redirect: indexcAmyIMIKInERpZsbNCkpas72IYqRceCD3gvaFy_qxtIMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/delete-account/index.vue")
  },
  {
    name: index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta?.name ?? "delivery-bus-rental___en",
    path: index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta?.path ?? "/en/passenger-delivery-bus-rental",
    props: index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta?.props ?? false,
    meta: index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta || {},
    alias: index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta?.alias || [],
    redirect: index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/delivery-bus-rental/index.vue")
  },
  {
    name: index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta?.name ?? "delivery-bus-rental___pl",
    path: index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta?.path ?? "/pl/wynajem-busow-dostawczych",
    props: index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta?.props ?? false,
    meta: index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta || {},
    alias: index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta?.alias || [],
    redirect: index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/delivery-bus-rental/index.vue")
  },
  {
    name: indexrLEoJ_45Yma8AgZDht2PNuSqLmua6Cud2CEhI4TuPDdZoMeta?.name ?? "documents___en",
    path: indexrLEoJ_45Yma8AgZDht2PNuSqLmua6Cud2CEhI4TuPDdZoMeta?.path ?? "/en/documents",
    props: indexrLEoJ_45Yma8AgZDht2PNuSqLmua6Cud2CEhI4TuPDdZoMeta?.props ?? false,
    meta: indexrLEoJ_45Yma8AgZDht2PNuSqLmua6Cud2CEhI4TuPDdZoMeta || {},
    alias: indexrLEoJ_45Yma8AgZDht2PNuSqLmua6Cud2CEhI4TuPDdZoMeta?.alias || [],
    redirect: indexrLEoJ_45Yma8AgZDht2PNuSqLmua6Cud2CEhI4TuPDdZoMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/documents/index.vue")
  },
  {
    name: indexrLEoJ_45Yma8AgZDht2PNuSqLmua6Cud2CEhI4TuPDdZoMeta?.name ?? "documents___pl",
    path: indexrLEoJ_45Yma8AgZDht2PNuSqLmua6Cud2CEhI4TuPDdZoMeta?.path ?? "/pl/dokumenty",
    props: indexrLEoJ_45Yma8AgZDht2PNuSqLmua6Cud2CEhI4TuPDdZoMeta?.props ?? false,
    meta: indexrLEoJ_45Yma8AgZDht2PNuSqLmua6Cud2CEhI4TuPDdZoMeta || {},
    alias: indexrLEoJ_45Yma8AgZDht2PNuSqLmua6Cud2CEhI4TuPDdZoMeta?.alias || [],
    redirect: indexrLEoJ_45Yma8AgZDht2PNuSqLmua6Cud2CEhI4TuPDdZoMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/documents/index.vue")
  },
  {
    name: indexXGPueQXfTohB_45GGjq__45wbjXMRBpeXbsl065C4fFjG2EMeta?.name ?? "electric-car-rental___en",
    path: indexXGPueQXfTohB_45GGjq__45wbjXMRBpeXbsl065C4fFjG2EMeta?.path ?? "/en/electric-car-rental",
    props: indexXGPueQXfTohB_45GGjq__45wbjXMRBpeXbsl065C4fFjG2EMeta?.props ?? false,
    meta: indexXGPueQXfTohB_45GGjq__45wbjXMRBpeXbsl065C4fFjG2EMeta || {},
    alias: indexXGPueQXfTohB_45GGjq__45wbjXMRBpeXbsl065C4fFjG2EMeta?.alias || [],
    redirect: indexXGPueQXfTohB_45GGjq__45wbjXMRBpeXbsl065C4fFjG2EMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/electric-car-rental/index.vue")
  },
  {
    name: indexXGPueQXfTohB_45GGjq__45wbjXMRBpeXbsl065C4fFjG2EMeta?.name ?? "electric-car-rental___pl",
    path: indexXGPueQXfTohB_45GGjq__45wbjXMRBpeXbsl065C4fFjG2EMeta?.path ?? "/pl/wypozyczalnia-samochodow-elektrycznych",
    props: indexXGPueQXfTohB_45GGjq__45wbjXMRBpeXbsl065C4fFjG2EMeta?.props ?? false,
    meta: indexXGPueQXfTohB_45GGjq__45wbjXMRBpeXbsl065C4fFjG2EMeta || {},
    alias: indexXGPueQXfTohB_45GGjq__45wbjXMRBpeXbsl065C4fFjG2EMeta?.alias || [],
    redirect: indexXGPueQXfTohB_45GGjq__45wbjXMRBpeXbsl065C4fFjG2EMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/electric-car-rental/index.vue")
  },
  {
    name: indexExboAN5BgVPlFbSyMtusNAdZuLF_DrGHlx23DnHWIAkMeta?.name ?? "faq___en",
    path: indexExboAN5BgVPlFbSyMtusNAdZuLF_DrGHlx23DnHWIAkMeta?.path ?? "/en/faq",
    props: indexExboAN5BgVPlFbSyMtusNAdZuLF_DrGHlx23DnHWIAkMeta?.props ?? false,
    meta: indexExboAN5BgVPlFbSyMtusNAdZuLF_DrGHlx23DnHWIAkMeta || {},
    alias: indexExboAN5BgVPlFbSyMtusNAdZuLF_DrGHlx23DnHWIAkMeta?.alias || [],
    redirect: indexExboAN5BgVPlFbSyMtusNAdZuLF_DrGHlx23DnHWIAkMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/faq/index.vue")
  },
  {
    name: indexExboAN5BgVPlFbSyMtusNAdZuLF_DrGHlx23DnHWIAkMeta?.name ?? "faq___pl",
    path: indexExboAN5BgVPlFbSyMtusNAdZuLF_DrGHlx23DnHWIAkMeta?.path ?? "/pl/faq",
    props: indexExboAN5BgVPlFbSyMtusNAdZuLF_DrGHlx23DnHWIAkMeta?.props ?? false,
    meta: indexExboAN5BgVPlFbSyMtusNAdZuLF_DrGHlx23DnHWIAkMeta || {},
    alias: indexExboAN5BgVPlFbSyMtusNAdZuLF_DrGHlx23DnHWIAkMeta?.alias || [],
    redirect: indexExboAN5BgVPlFbSyMtusNAdZuLF_DrGHlx23DnHWIAkMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/faq/index.vue")
  },
  {
    name: indexdjYiYxrZo4jvcwH8e3cNpHWk44665A7mVcTcP9P8Tf8Meta?.name ?? "general-terms-and-conditions___en",
    path: indexdjYiYxrZo4jvcwH8e3cNpHWk44665A7mVcTcP9P8Tf8Meta?.path ?? "/en/general-terms",
    props: indexdjYiYxrZo4jvcwH8e3cNpHWk44665A7mVcTcP9P8Tf8Meta?.props ?? false,
    meta: indexdjYiYxrZo4jvcwH8e3cNpHWk44665A7mVcTcP9P8Tf8Meta || {},
    alias: indexdjYiYxrZo4jvcwH8e3cNpHWk44665A7mVcTcP9P8Tf8Meta?.alias || [],
    redirect: indexdjYiYxrZo4jvcwH8e3cNpHWk44665A7mVcTcP9P8Tf8Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/general-terms-and-conditions/index.vue")
  },
  {
    name: indexdjYiYxrZo4jvcwH8e3cNpHWk44665A7mVcTcP9P8Tf8Meta?.name ?? "general-terms-and-conditions___pl",
    path: indexdjYiYxrZo4jvcwH8e3cNpHWk44665A7mVcTcP9P8Tf8Meta?.path ?? "/pl/owu",
    props: indexdjYiYxrZo4jvcwH8e3cNpHWk44665A7mVcTcP9P8Tf8Meta?.props ?? false,
    meta: indexdjYiYxrZo4jvcwH8e3cNpHWk44665A7mVcTcP9P8Tf8Meta || {},
    alias: indexdjYiYxrZo4jvcwH8e3cNpHWk44665A7mVcTcP9P8Tf8Meta?.alias || [],
    redirect: indexdjYiYxrZo4jvcwH8e3cNpHWk44665A7mVcTcP9P8Tf8Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/general-terms-and-conditions/index.vue")
  },
  {
    name: indexzU8cBsowFdhoI47By5CQCeWGuEfwMVmVz9FCpZUnZ78Meta?.name ?? "holiday-abroad-rental___en",
    path: indexzU8cBsowFdhoI47By5CQCeWGuEfwMVmVz9FCpZUnZ78Meta?.path ?? "/en/wynajem-auta-na-wakacje-za-granica",
    props: indexzU8cBsowFdhoI47By5CQCeWGuEfwMVmVz9FCpZUnZ78Meta?.props ?? false,
    meta: indexzU8cBsowFdhoI47By5CQCeWGuEfwMVmVz9FCpZUnZ78Meta || {},
    alias: indexzU8cBsowFdhoI47By5CQCeWGuEfwMVmVz9FCpZUnZ78Meta?.alias || [],
    redirect: indexzU8cBsowFdhoI47By5CQCeWGuEfwMVmVz9FCpZUnZ78Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/holiday-abroad-rental/index.vue")
  },
  {
    name: indexzU8cBsowFdhoI47By5CQCeWGuEfwMVmVz9FCpZUnZ78Meta?.name ?? "holiday-abroad-rental___pl",
    path: indexzU8cBsowFdhoI47By5CQCeWGuEfwMVmVz9FCpZUnZ78Meta?.path ?? "/pl/wynajem-auta-na-wakacje-za-granica",
    props: indexzU8cBsowFdhoI47By5CQCeWGuEfwMVmVz9FCpZUnZ78Meta?.props ?? false,
    meta: indexzU8cBsowFdhoI47By5CQCeWGuEfwMVmVz9FCpZUnZ78Meta || {},
    alias: indexzU8cBsowFdhoI47By5CQCeWGuEfwMVmVz9FCpZUnZ78Meta?.alias || [],
    redirect: indexzU8cBsowFdhoI47By5CQCeWGuEfwMVmVz9FCpZUnZ78Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/holiday-abroad-rental/index.vue")
  },
  {
    name: indexzY7P9_h0HCeqKJXBnldLFsgwGCYN9WdaaAQaqjRaqU0Meta?.name ?? "holiday-rental___en",
    path: indexzY7P9_h0HCeqKJXBnldLFsgwGCYN9WdaaAQaqjRaqU0Meta?.path ?? "/en/wynajem-auta-na-wakacje",
    props: indexzY7P9_h0HCeqKJXBnldLFsgwGCYN9WdaaAQaqjRaqU0Meta?.props ?? false,
    meta: indexzY7P9_h0HCeqKJXBnldLFsgwGCYN9WdaaAQaqjRaqU0Meta || {},
    alias: indexzY7P9_h0HCeqKJXBnldLFsgwGCYN9WdaaAQaqjRaqU0Meta?.alias || [],
    redirect: indexzY7P9_h0HCeqKJXBnldLFsgwGCYN9WdaaAQaqjRaqU0Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/holiday-rental/index.vue")
  },
  {
    name: indexzY7P9_h0HCeqKJXBnldLFsgwGCYN9WdaaAQaqjRaqU0Meta?.name ?? "holiday-rental___pl",
    path: indexzY7P9_h0HCeqKJXBnldLFsgwGCYN9WdaaAQaqjRaqU0Meta?.path ?? "/pl/wynajem-auta-na-wakacje",
    props: indexzY7P9_h0HCeqKJXBnldLFsgwGCYN9WdaaAQaqjRaqU0Meta?.props ?? false,
    meta: indexzY7P9_h0HCeqKJXBnldLFsgwGCYN9WdaaAQaqjRaqU0Meta || {},
    alias: indexzY7P9_h0HCeqKJXBnldLFsgwGCYN9WdaaAQaqjRaqU0Meta?.alias || [],
    redirect: indexzY7P9_h0HCeqKJXBnldLFsgwGCYN9WdaaAQaqjRaqU0Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/holiday-rental/index.vue")
  },
  {
    name: indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta?.name ?? "index___en",
    path: indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta?.path ?? "/en",
    props: indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta?.props ?? false,
    meta: indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta || {},
    alias: indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta?.alias || [],
    redirect: indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/index/index.vue")
  },
  {
    name: indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta?.name ?? "insurance-replacement___en",
    path: indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta?.path ?? "/en/a-replacement-car-from-the-perpetrators-liability-insurance",
    props: indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta?.props ?? false,
    meta: indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta || {},
    alias: indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta?.alias || [],
    redirect: indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/insurance-replacement/index.vue")
  },
  {
    name: indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta?.name ?? "insurance-replacement___pl",
    path: indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta?.path ?? "/pl/wynajem-z-oc-sprawcy",
    props: indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta?.props ?? false,
    meta: indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta || {},
    alias: indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta?.alias || [],
    redirect: indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/insurance-replacement/index.vue")
  },
  {
    name: indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta?.name ?? "locations___en",
    path: indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta?.path ?? "/en/branches",
    props: indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta?.props ?? false,
    meta: indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta || {},
    alias: indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta?.alias || [],
    redirect: indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/locations/index.vue")
  },
  {
    name: indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta?.name ?? "locations___pl",
    path: indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta?.path ?? "/pl/oddzialy",
    props: indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta?.props ?? false,
    meta: indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta || {},
    alias: indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta?.alias || [],
    redirect: indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/locations/index.vue")
  },
  {
    name: index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta?.name ?? "long-term___en",
    path: index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta?.path ?? "/en/long-term-rental",
    props: index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta?.props ?? false,
    meta: index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta || {},
    alias: index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta?.alias || [],
    redirect: index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/long-term/index.vue")
  },
  {
    name: index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta?.name ?? "long-term___pl",
    path: index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta?.path ?? "/pl/wynajem-dlugoterminowy",
    props: index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta?.props ?? false,
    meta: index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta || {},
    alias: index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta?.alias || [],
    redirect: index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/long-term/index.vue")
  },
  {
    name: indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta?.name ?? "loyalty-program___en",
    path: indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta?.path ?? "/en/loyalty-program",
    props: indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta?.props ?? false,
    meta: indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta || {},
    alias: indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta?.alias || [],
    redirect: indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/loyalty-program/index.vue")
  },
  {
    name: indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta?.name ?? "loyalty-program___pl",
    path: indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta?.path ?? "/pl/program-lojalnosciowy",
    props: indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta?.props ?? false,
    meta: indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta || {},
    alias: indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta?.alias || [],
    redirect: indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/loyalty-program/index.vue")
  },
  {
    name: index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta?.name ?? "medium-term___en",
    path: index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta?.path ?? "/en/medium-term-rental",
    props: index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta?.props ?? false,
    meta: index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta || {},
    alias: index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta?.alias || [],
    redirect: index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/medium-term/index.vue")
  },
  {
    name: index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta?.name ?? "medium-term___pl",
    path: index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta?.path ?? "/pl/wynajem-srednioterminowy",
    props: index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta?.props ?? false,
    meta: index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta || {},
    alias: index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta?.alias || [],
    redirect: index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/medium-term/index.vue")
  },
  {
    name: indexNvjP9wySKf3_aee8kWRb4UnByot3_45AUbm17sgDLRUrIMeta?.name ?? "privacy-policy___en",
    path: indexNvjP9wySKf3_aee8kWRb4UnByot3_45AUbm17sgDLRUrIMeta?.path ?? "/en/policy",
    props: indexNvjP9wySKf3_aee8kWRb4UnByot3_45AUbm17sgDLRUrIMeta?.props ?? false,
    meta: indexNvjP9wySKf3_aee8kWRb4UnByot3_45AUbm17sgDLRUrIMeta || {},
    alias: indexNvjP9wySKf3_aee8kWRb4UnByot3_45AUbm17sgDLRUrIMeta?.alias || [],
    redirect: indexNvjP9wySKf3_aee8kWRb4UnByot3_45AUbm17sgDLRUrIMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/privacy-policy/index.vue")
  },
  {
    name: indexNvjP9wySKf3_aee8kWRb4UnByot3_45AUbm17sgDLRUrIMeta?.name ?? "privacy-policy___pl",
    path: indexNvjP9wySKf3_aee8kWRb4UnByot3_45AUbm17sgDLRUrIMeta?.path ?? "/pl/polityka",
    props: indexNvjP9wySKf3_aee8kWRb4UnByot3_45AUbm17sgDLRUrIMeta?.props ?? false,
    meta: indexNvjP9wySKf3_aee8kWRb4UnByot3_45AUbm17sgDLRUrIMeta || {},
    alias: indexNvjP9wySKf3_aee8kWRb4UnByot3_45AUbm17sgDLRUrIMeta?.alias || [],
    redirect: indexNvjP9wySKf3_aee8kWRb4UnByot3_45AUbm17sgDLRUrIMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/privacy-policy/index.vue")
  },
  {
    name: indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta?.name ?? "refrigeration-van-rental___en",
    path: indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta?.path ?? "/en/refrigeration-van-rental",
    props: indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta?.props ?? false,
    meta: indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta || {},
    alias: indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta?.alias || [],
    redirect: indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/refrigeration-van-rental/index.vue")
  },
  {
    name: indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta?.name ?? "refrigeration-van-rental___pl",
    path: indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta?.path ?? "/pl/wynajem-samochodu-chlodnia",
    props: indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta?.props ?? false,
    meta: indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta || {},
    alias: indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta?.alias || [],
    redirect: indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/refrigeration-van-rental/index.vue")
  },
  {
    name: indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta?.name ?? "rent-tesla___en",
    path: indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta?.path ?? "/en/rent-tesla",
    props: indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta?.props ?? false,
    meta: indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta || {},
    alias: indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta?.alias || [],
    redirect: indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/rent-tesla/index.vue")
  },
  {
    name: indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta?.name ?? "rent-tesla___pl",
    path: indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta?.path ?? "/pl/tesla-wynajem",
    props: indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta?.props ?? false,
    meta: indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta || {},
    alias: indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta?.alias || [],
    redirect: indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/rent-tesla/index.vue")
  },
  {
    name: indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta?.name ?? "reservation-completed-orderID___en",
    path: indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta?.path ?? "/en/reservation-summary/:orderID()",
    props: indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta?.props ?? false,
    meta: indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta || {},
    alias: indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta?.alias || [],
    redirect: indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/reservation/completed/[orderID]/index.vue")
  },
  {
    name: indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta?.name ?? "reservation-completed-orderID___pl",
    path: indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta?.path ?? "/pl/podsumowanie-rezerwacji/:orderID()",
    props: indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta?.props ?? false,
    meta: indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta || {},
    alias: indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta?.alias || [],
    redirect: indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/reservation/completed/[orderID]/index.vue")
  },
  {
    name: indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta?.name ?? "reservation___en",
    path: indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta?.path ?? "/en/reservation",
    props: indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta?.props ?? false,
    meta: indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta || {},
    alias: indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta?.alias || [],
    redirect: indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/reservation/index.vue")
  },
  {
    name: indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta?.name ?? "reservation___pl",
    path: indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta?.path ?? "/pl/rezerwacja",
    props: indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta?.props ?? false,
    meta: indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta || {},
    alias: indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta?.alias || [],
    redirect: indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/reservation/index.vue")
  },
  {
    name: index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta?.name ?? "short-term___en",
    path: index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta?.path ?? "/en/short-term-rental",
    props: index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta?.props ?? false,
    meta: index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta || {},
    alias: index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta?.alias || [],
    redirect: index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/short-term/index.vue")
  },
  {
    name: index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta?.name ?? "short-term___pl",
    path: index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta?.path ?? "/pl/wynajem-krotkoterminowy",
    props: index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta?.props ?? false,
    meta: index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta || {},
    alias: index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta?.alias || [],
    redirect: index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/short-term/index.vue")
  },
  {
    name: indexKE3SzNPACD6Is2mCcJSJWHe5CfRqWmfWoLONcYsyU3cMeta?.name ?? "sign-in___en",
    path: indexKE3SzNPACD6Is2mCcJSJWHe5CfRqWmfWoLONcYsyU3cMeta?.path ?? "/en/sign-in",
    props: indexKE3SzNPACD6Is2mCcJSJWHe5CfRqWmfWoLONcYsyU3cMeta?.props ?? false,
    meta: indexKE3SzNPACD6Is2mCcJSJWHe5CfRqWmfWoLONcYsyU3cMeta || {},
    alias: indexKE3SzNPACD6Is2mCcJSJWHe5CfRqWmfWoLONcYsyU3cMeta?.alias || [],
    redirect: indexKE3SzNPACD6Is2mCcJSJWHe5CfRqWmfWoLONcYsyU3cMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/sign-in/index.vue")
  },
  {
    name: indexKE3SzNPACD6Is2mCcJSJWHe5CfRqWmfWoLONcYsyU3cMeta?.name ?? "sign-in___pl",
    path: indexKE3SzNPACD6Is2mCcJSJWHe5CfRqWmfWoLONcYsyU3cMeta?.path ?? "/pl/logowanie",
    props: indexKE3SzNPACD6Is2mCcJSJWHe5CfRqWmfWoLONcYsyU3cMeta?.props ?? false,
    meta: indexKE3SzNPACD6Is2mCcJSJWHe5CfRqWmfWoLONcYsyU3cMeta || {},
    alias: indexKE3SzNPACD6Is2mCcJSJWHe5CfRqWmfWoLONcYsyU3cMeta?.alias || [],
    redirect: indexKE3SzNPACD6Is2mCcJSJWHe5CfRqWmfWoLONcYsyU3cMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/sign-in/index.vue")
  },
  {
    name: indexxR9dnca3GnBhVzS7HkfJPz2ac9t7r9CeiWj1VA5gEbYMeta?.name ?? "terms-of-service___en",
    path: indexxR9dnca3GnBhVzS7HkfJPz2ac9t7r9CeiWj1VA5gEbYMeta?.path ?? "/en/regulations",
    props: indexxR9dnca3GnBhVzS7HkfJPz2ac9t7r9CeiWj1VA5gEbYMeta?.props ?? false,
    meta: indexxR9dnca3GnBhVzS7HkfJPz2ac9t7r9CeiWj1VA5gEbYMeta || {},
    alias: indexxR9dnca3GnBhVzS7HkfJPz2ac9t7r9CeiWj1VA5gEbYMeta?.alias || [],
    redirect: indexxR9dnca3GnBhVzS7HkfJPz2ac9t7r9CeiWj1VA5gEbYMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/terms-of-service/index.vue")
  },
  {
    name: indexxR9dnca3GnBhVzS7HkfJPz2ac9t7r9CeiWj1VA5gEbYMeta?.name ?? "terms-of-service___pl",
    path: indexxR9dnca3GnBhVzS7HkfJPz2ac9t7r9CeiWj1VA5gEbYMeta?.path ?? "/pl/regulamin",
    props: indexxR9dnca3GnBhVzS7HkfJPz2ac9t7r9CeiWj1VA5gEbYMeta?.props ?? false,
    meta: indexxR9dnca3GnBhVzS7HkfJPz2ac9t7r9CeiWj1VA5gEbYMeta || {},
    alias: indexxR9dnca3GnBhVzS7HkfJPz2ac9t7r9CeiWj1VA5gEbYMeta?.alias || [],
    redirect: indexxR9dnca3GnBhVzS7HkfJPz2ac9t7r9CeiWj1VA5gEbYMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/terms-of-service/index.vue")
  },
  {
    name: indexxnt_457_45JeCffk_9ux0L4N0LipsCcSuMSLtxCbEgzFI10Meta?.name ?? "verify-email___en",
    path: indexxnt_457_45JeCffk_9ux0L4N0LipsCcSuMSLtxCbEgzFI10Meta?.path ?? "/en/verify-email",
    props: indexxnt_457_45JeCffk_9ux0L4N0LipsCcSuMSLtxCbEgzFI10Meta?.props ?? false,
    meta: indexxnt_457_45JeCffk_9ux0L4N0LipsCcSuMSLtxCbEgzFI10Meta || {},
    alias: indexxnt_457_45JeCffk_9ux0L4N0LipsCcSuMSLtxCbEgzFI10Meta?.alias || [],
    redirect: indexxnt_457_45JeCffk_9ux0L4N0LipsCcSuMSLtxCbEgzFI10Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/verify-email/index.vue")
  },
  {
    name: indexxnt_457_45JeCffk_9ux0L4N0LipsCcSuMSLtxCbEgzFI10Meta?.name ?? "verify-email___pl",
    path: indexxnt_457_45JeCffk_9ux0L4N0LipsCcSuMSLtxCbEgzFI10Meta?.path ?? "/pl/zweryfikuj-email",
    props: indexxnt_457_45JeCffk_9ux0L4N0LipsCcSuMSLtxCbEgzFI10Meta?.props ?? false,
    meta: indexxnt_457_45JeCffk_9ux0L4N0LipsCcSuMSLtxCbEgzFI10Meta || {},
    alias: indexxnt_457_45JeCffk_9ux0L4N0LipsCcSuMSLtxCbEgzFI10Meta?.alias || [],
    redirect: indexxnt_457_45JeCffk_9ux0L4N0LipsCcSuMSLtxCbEgzFI10Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/verify-email/index.vue")
  },
  {
    name: indexBggzO1uP_45_45gMJuHAKxtuibnRB8VU_j_45CcGtOgbDnpXsMeta?.name ?? "weekend-rental___en",
    path: indexBggzO1uP_45_45gMJuHAKxtuibnRB8VU_j_45CcGtOgbDnpXsMeta?.path ?? "/en/wynajem-auta-na-weekend",
    props: indexBggzO1uP_45_45gMJuHAKxtuibnRB8VU_j_45CcGtOgbDnpXsMeta?.props ?? false,
    meta: indexBggzO1uP_45_45gMJuHAKxtuibnRB8VU_j_45CcGtOgbDnpXsMeta || {},
    alias: indexBggzO1uP_45_45gMJuHAKxtuibnRB8VU_j_45CcGtOgbDnpXsMeta?.alias || [],
    redirect: indexBggzO1uP_45_45gMJuHAKxtuibnRB8VU_j_45CcGtOgbDnpXsMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/weekend-rental/index.vue")
  },
  {
    name: indexBggzO1uP_45_45gMJuHAKxtuibnRB8VU_j_45CcGtOgbDnpXsMeta?.name ?? "weekend-rental___pl",
    path: indexBggzO1uP_45_45gMJuHAKxtuibnRB8VU_j_45CcGtOgbDnpXsMeta?.path ?? "/pl/wynajem-auta-na-weekend",
    props: indexBggzO1uP_45_45gMJuHAKxtuibnRB8VU_j_45CcGtOgbDnpXsMeta?.props ?? false,
    meta: indexBggzO1uP_45_45gMJuHAKxtuibnRB8VU_j_45CcGtOgbDnpXsMeta || {},
    alias: indexBggzO1uP_45_45gMJuHAKxtuibnRB8VU_j_45CcGtOgbDnpXsMeta?.alias || [],
    redirect: indexBggzO1uP_45_45gMJuHAKxtuibnRB8VU_j_45CcGtOgbDnpXsMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/weekend-rental/index.vue")
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name ?? undefined,
    path: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.path ?? "/panel",
    props: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.props ?? false,
    meta: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta || {},
    alias: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.alias || [],
    redirect: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.redirect,
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name ?? undefined,
    path: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.path ?? "/pl",
    props: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.props ?? false,
    meta: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta || {},
    alias: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.alias || [],
    redirect: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.redirect,
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name ?? undefined,
    path: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.path ?? "/sitemap.xml",
    props: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.props ?? false,
    meta: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta || {},
    alias: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.alias || [],
    redirect: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.redirect,
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name ?? undefined,
    path: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.path ?? "/sitemap_pages_0-sitemap.xml",
    props: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.props ?? false,
    meta: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta || {},
    alias: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.alias || [],
    redirect: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.redirect,
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name ?? undefined,
    path: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.path ?? "/sitemap_pages_1-sitemap.xml",
    props: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.props ?? false,
    meta: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta || {},
    alias: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.alias || [],
    redirect: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.redirect,
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name ?? undefined,
    path: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.path ?? "/sitemap_places_0-sitemap.xml",
    props: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.props ?? false,
    meta: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta || {},
    alias: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.alias || [],
    redirect: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.redirect,
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name ?? undefined,
    path: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.path ?? "/sitemap_places_1-sitemap.xml",
    props: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.props ?? false,
    meta: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta || {},
    alias: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.alias || [],
    redirect: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.redirect,
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name ?? undefined,
    path: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.path ?? "/sitemap_blog_0-sitemap.xml",
    props: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.props ?? false,
    meta: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta || {},
    alias: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.alias || [],
    redirect: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.redirect,
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name ?? undefined,
    path: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.path ?? "/sitemap_blog_1-sitemap.xml",
    props: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.props ?? false,
    meta: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta || {},
    alias: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.alias || [],
    redirect: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.redirect,
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  }
]